import fetch from '@/utils/fetch';
import { message } from 'antd';

const model = {
  state: {
    accountParams: {
      pageNo: 1,
      pageSize: 10,
    },
    tableLoading: false,
    roleList: [],
    permissionList: [],
    accountList: [],
    accountTotal: 0,
    searchRoles: [],
    currentAccount: null,
  },
  reducers: {
    setState(state, partialState) {
      return { ...state, ...partialState };
    },
    clearCurrentAccount(state) {
      return { ...state, currentAccount: null };
    },
  },
  actions: ({ dispatch: { privilegeAccount }, getState }) => ({
    // 获取用户列表
    async getAccountList() {
      const { accountParams } = getState().privilegeAccount;
      const data = await fetch('/saasmerchant/web/auth/account/page', {
        type: 'POST',
        params: { ...accountParams, platformCode: 'FS' },
        useJson: true,
      });
      if (data) {
        privilegeAccount.setState({ accountList: data.data, accountTotal: data.total });
      }
    },
    setFilter(params) {
      const { accountParams } = getState().privilegeAccount;
      privilegeAccount.setState({ accountParams: { ...accountParams, ...params } });
    },
    initFilter() {
      privilegeAccount.setState({ accountParams: { pageNo: 1, pageSize: 10 } });
    },
    // 编辑用户
    async editAccount(params, history) {
      const data = await fetch('/saasmerchant/web/auth/account/edit', {
        type: 'POST',
        params: { ...params, platformCode: 'FS' },
        useJson: true,
      });
      if (data) {
        message.success('编辑成功');
        const { accountParams } = getState().privilegeAccount;
        privilegeAccount.setState({ accountParams: { ...accountParams, pageNo: 1 } });
        history.push('/privilege/account');
      } else {
        message.error('编辑失败');
      }
    },
    // 新增用户
    async addAccount(params, history) {
      const data = await fetch('/saasmerchant/web/auth/account/create', {
        type: 'POST',
        params: { ...params, platformCode: 'FS' },
        useJson: true,
      });
      if (data) {
        message.success('新增成功');
        const { accountParams } = getState().privilegeAccount;
        privilegeAccount.setState({ accountParams: { ...accountParams, pageNo: 1 } });
        history.push('/privilege/account');
      } else {
        message.error('新增失败');
      }
    },

    // 重置密码
    async resetPassword(params) {
      const data = await fetch('/saasmerchant/web/auth/account/password/reset', {
        type: 'POST',
        params,
      });
      if (data) {
        message.success('重置成功');
        privilegeAccount.getAccountList();
      } else {
        message.error('重置失败');
      }
    },
    // 编辑用户状态
    async editStatus(params) {
      const { errno, errmsg, data } = await fetch('/saasmerchant/web/auth/account/editStatus', {
        type: 'POST',
        params,
        getAllResponseData: true,
      });
      if (errno === 0 && data) {
        privilegeAccount.getAccountList();
        message.success('修改成功');
      } else {
        message.error(errmsg || '修改失败');
      }
    },

    // 根据角色名称搜索角色
    async getSearchRoleList() {
      const data = await fetch('/saasmerchant/web/auth/role/list/condition/name', {
        params: {
          platformCode: 'FS',
          // roleName: '', // 不传拉取指定platformCode下的所有角色
        },
      });
      if (data) {
        const roles = data.map((role) => {
          return {
            key: role.roleId,
            title: role.roleName,
          };
        });
        privilegeAccount.setState({
          searchRoles: roles,
        });
      } else {
        privilegeAccount.setState({
          searchRoles: [],
        });
      }
    },

    // 根据角色名称搜索角色
    async getBomsSearchRoleList() {
      const data = await fetch('/saasmerchant/web/auth/role/list/condition/name', {
        params: {
          platformCode: 'BOMS',
          // roleName: '', // 不传拉取指定platformCode下的所有角色
        },
      });
      if (data) {
        const roles = data.map((role) => {
          return {
            key: role.roleId,
            title: role.roleName,
          };
        });
        privilegeAccount.setState({
          bomsSearchRoles: roles,
        });
      } else {
        privilegeAccount.setState({
          bomsSearchRoles: [],
        });
      }
    },

    // 查询用户信息
    async getAccountData(params) {
      const data = await fetch('/saasmerchant/web/auth/account/info', {
        params,
      });
      if (data) {
        privilegeAccount.setState({
          currentAccount: data,
        });
      } else {
        privilegeAccount.setState({
          currentAccount: null,
        });
      }
    },
  }),
};

export default model;
